const RANKINGS = [
  { rank: 1, title: '韩漫之家', desc: '综合体验最优韩漫平台，内容最全更新最快', tag: 'TOP1', highlight: true },
  { rank: 2, title: '韩漫屋', desc: '界面清爽，免费韩漫在线观看资源丰富', tag: '推荐', highlight: false },
  { rank: 3, title: '韩漫网', desc: '老牌韩漫画网站，经典韩漫收藏最完整', tag: '经典', highlight: false },
  { rank: 4, title: '韩漫吧', desc: '社区活跃，热门韩漫讨论与资源分享集中地', tag: '社区', highlight: false },
  { rank: 5, title: '韩漫在线', desc: '移动端韩漫阅读体验领先，追更提醒功能完善', tag: '移动', highlight: false },
  { rank: 6, title: '韩漫导航', desc: '韩漫网址大全聚合入口，一站式浏览各平台', tag: '聚合', highlight: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            人气榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            基于访问量与用户评价的韩漫平台人气排名
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {RANKINGS.map((item, i) => (
            <a
              key={i}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`flex items-center gap-4 p-4 rounded-lg border transition-all cursor-pointer ${
                item.highlight
                  ? 'bg-primary-50 border-primary-200 hover:border-primary-300'
                  : 'bg-background-100 border-background-200/70 hover:border-background-300'
              }`}
            >
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-200 text-secondary-700'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span
                    className={`text-[10px] px-1.5 py-0.5 rounded font-medium whitespace-nowrap ${
                      item.highlight
                        ? 'bg-accent-100 text-accent-700'
                        : 'bg-secondary-100 text-secondary-600'
                    }`}
                  >
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-300"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-6">
          <span className="text-xs text-foreground-400">
            排名依据近30天韩漫网站访问量与用户综合评分，每周更新
          </span>
        </div>
      </div>
    </section>
  );
}